/* global rp$, document, window */
var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');

	/********************************************
	 * Load Javascript for the Interchange products Module
	 * -----------------------------------------
	 * @section product_interchange_js
	 ********************************************/
	(function ProductInterchangeModule() {
		var $interchangeModules;

		/********************************************
		.* Attach
		.* -----------------------------------------
		.* Attach events to each module instance
		.********************************************/
		function attachEvents() {
			$interchangeModules = rp$('.product-interchange-module');

			rp$.each($interchangeModules, function DropDownMenu_Iterator(idx, interchangeModule) {
				var $interchangeModule = rp$(interchangeModule);
				var wrapper = $interchangeModule.find('.product-interchange-container');

				$interchangeModule.on('click', '.product-interchange-expand-button', function Expand_Interchange() {
					if (wrapper.hasClass('collapsed')) {
						wrapper.removeClass('collapsed');
					} else {
						wrapper.addClass('collapsed');
					}
				});
			});
		}

		function HandleProductInterchangeResponse({$recommendedContentEle, $interchangeResponseEle}) {
			return function (evt, response) {
				$interchangeResponseEle.html(response);
				attachEvents();
			};
		}

		$onReady({
			rp$, window,
			label: 'product_interchange',
			fn: function () {
				var $interchangeModules = rp$('.product-interchange-module');

				rp$.each($interchangeModules, function DropDownMenu_Iterator(idx, product_interchange_module) {
					var $recommendedContentEle = rp$(product_interchange_module).find('.product-interchange');
					var $interchangeResponseEle = rp$(product_interchange_module).find('.product-interchange-table');

					const eventHandler = HandleProductInterchangeResponse({
						$recommendedContentEle,
						$interchangeResponseEle,
					});

					/* Handle Interchange Response
					.*-----------------------------------------*/
					// Due to plugin, all things that depend on document and window are up for causing bugs. Lets clean up before we start
					rp$(document).off('productGetInterchangeInfo:response', eventHandler);
					rp$(document).on('productGetInterchangeInfo:response', eventHandler);
				}); // END rp$.each module
			},
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
